export default "__VITE_ASSET__C3YR77Rc__"